import { BASE_SERVICE_URL } from '../../../lib/constants'
import type S3 from '../interface/s3Integration';

const list = async (): Promise<S3[]> => {
    try {
        const listResult = await fetch(BASE_SERVICE_URL + `/s3/list`, {
            credentials: 'same-origin',
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }) as S3[]
        return listResult;
    } catch (error) {
        return []
    }
}



export default list